import { OETrans } from '@components/translation/OETrans';
import React from 'react';
import { Nav, Row, Tab } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

type TabNavItemType = {
	eventKey: string;
	title: string;
	transCode: string;
	content: React.ReactNode;
	disabled?: boolean;
	shouldBeVisible?: boolean;
};

interface NavTabsProps {
	tabNavItems: TabNavItemType[];
	onValueChangeCallback?: (key: string) => void;
}

const NavTabs: React.FC<NavTabsProps> = ({ tabNavItems, onValueChangeCallback }) => {
	const history = useHistory();
	const location = useLocation();
	const defaultActiveKey = location.hash
		? location.hash.replace('#', '')
		: tabNavItems.filter((tabNavItem) => !('shouldBeVisible' in tabNavItem) || tabNavItem.shouldBeVisible)[0].eventKey;
	return (
		<Tab.Container
			defaultActiveKey={defaultActiveKey}
			onSelect={(key) => {
				history.replace(`#${key}`);
				onValueChangeCallback && onValueChangeCallback(key);
			}}
		>
			<Nav className="custom-nav-tabs">
				{tabNavItems.map((tab) => {
					if ('shouldBeVisible' in tab && !tab.shouldBeVisible) return null;
					return (
						<Nav.Item key={tab.eventKey}>
							<Nav.Link eventKey={tab.eventKey} disabled={tab.disabled}>
								<OETrans code={tab.transCode} fallback={tab.title} />
							</Nav.Link>
						</Nav.Item>
					);
				})}
			</Nav>
			<div className="candidacy simple-box scenaritab custom-nav-tabs__content_container">
				<Row>
					<Tab.Content>
						{tabNavItems.map((tab) => {
							if (tab.shouldBeVisible === false) return null;
							if (tab.eventKey !== defaultActiveKey) return null;
							return (
								<Tab.Pane key={tab.eventKey} eventKey={tab.eventKey}>
									{tab.content}
								</Tab.Pane>
							);
						})}
					</Tab.Content>
				</Row>
			</div>
		</Tab.Container>
	);
};

export default NavTabs;
